import { Component } from 'react';
import { connect } from 'react-redux';
import { TextKey } from '@mews-commander/enums';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedText } from '@mews/framework';

import {
    SpacingSmallTopBottom,
    SpacingMediumLeft,
    SpacingMediumAll,
    TooltippedSpan,
    SpacedPlusSign,
} from '@mews-commander/ui';

import { IconButton, IconName, Stack } from '@optimus-web/core';
import { isHoldingState, isUnconfirmedState } from '@mews-commander/types';
import { ServiceOrderState, ReservationTimeState } from '@mews-commander/legacy-data-structures';
import { getColorFromReservationTimeState, scrollIntoViewWithOptions } from '@mews-commander/utils';
import { getCurrentCompanionAccommodationExtent } from '@mews-commander/legacy-entities/src/selectors/reservations';
import { navigateToReservationDetail } from '../../shortcuts';
import { ReservationStateTag } from '../../../components/reservation/ReservationStateTag';
import { DatesRange } from './DatesRange';
import ResourceDetail from './ResourceDetail';
import {
    ReservationListItem,
    NoRoomIcon,
    ResourceDetailElement,
    ReservationDetailElement,
    ActionElement,
    ReservationDetailContent,
    OccupancyElement,
    ReservationListItemWrapper,
} from './styles';

interface Props {
    selected?: boolean;
    onNavigateTo?: (id: string, isReservation: boolean) => void;
}

class ReservationGroupDetailListItem extends Component<Props> {
    itemElement: $TSFixMe;

    componentDidMount() {
        this.scrollIntoView();
    }

    componentDidUpdate() {
        this.scrollIntoView();
    }

    scrollIntoView = () => {
        if (this.props.selected) {
            scrollIntoViewWithOptions(this.itemElement);
        }
    };

    // @ts-expect-error $TSFixMeError: Property 'navigateToGroupModule' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
    handleEditReservation = () => this.props.navigateToGroupModule(this.props.id);

    handleNavigateToReservation = () => {
        const {
            // @ts-expect-error $TSFixMeError: Property 'id' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
            id,
            onNavigateTo,
        } = this.props;
        onNavigateTo?.(id, true);
    };

    listItemRef = (c: $TSFixMe) => (this.itemElement = c);

    // @ts-expect-error $TSFixMeError: Property 'stateEnum' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
    isHolding = () => isHoldingState(this.props.stateEnum.name);

    render() {
        const {
            // @ts-expect-error $TSFixMeError: Property 'startUtc' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
            startUtc,
            // @ts-expect-error $TSFixMeError: Property 'endUtc' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
            endUtc,
            // @ts-expect-error $TSFixMeError: Property 'assignedResourceId' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
            assignedResourceId,
            selected,
            // @ts-expect-error $TSFixMeError: Property 'adultCount' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
            adultCount,
            // @ts-expect-error $TSFixMeError: Property 'childCount' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
            childCount,
            // @ts-expect-error $TSFixMeError: Property 'stateEnum' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
            stateEnum,
            // @ts-expect-error $TSFixMeError: Property 'timeStateEnum' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
            timeStateEnum,
            // @ts-expect-error $TSFixMeError: Property 'options' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
            options,
            // @ts-expect-error $TSFixMeError: Property 'timeState' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
            timeState,
            // @ts-expect-error $TSFixMeError: Property 'companionExtent' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
            companionExtent,
            // @ts-expect-error $TSFixMeError: Property 'serviceId' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
            serviceId,
        } = this.props;
        const resourceDetail = assignedResourceId ? (
            <ResourceDetail resourceId={assignedResourceId} serviceId={serviceId} />
        ) : (
            <TooltippedSpan tooltip={<LocalizedText textKey={TextKey.Unassigned} />}>
                {/* @ts-expect-error $TSFixMeError: No overload matches this call. */}
                <NoRoomIcon />
            </TooltippedSpan>
        );

        const occupancyTooltip = (
            <span>
                <LocalizedText textKey={TextKey.AdultPlural} />
                {UnicodeEntity.Colon}
                {UnicodeEntity.NoBreakSpace}
                {adultCount}
                <br />
                <LocalizedText textKey={TextKey.ChildPlural} />
                {UnicodeEntity.Colon}
                {UnicodeEntity.NoBreakSpace}
                {childCount}
            </span>
        );
        const occupancy = (
            <SpacingMediumLeft>
                <OccupancyElement>
                    <TooltippedSpan tooltip={occupancyTooltip}>
                        {`${adultCount}${SpacedPlusSign}${childCount}`}
                    </TooltippedSpan>
                </OccupancyElement>
            </SpacingMediumLeft>
        );

        const isHolding = this.isHolding();
        const isUnconfirmed = isUnconfirmedState(stateEnum.name);
        const borderColor = getColorFromReservationTimeState(timeState, { companionExtent, ...options }).active;
        return (
            <ReservationListItem ref={this.listItemRef}>
                <SpacingSmallTopBottom>
                    <ReservationListItemWrapper
                        // @ts-expect-error $TSFixMeError: No overload matches this call.
                        borderColor={borderColor}
                        selected={selected}
                        unconfirmed={isUnconfirmed}
                    >
                        <SpacingMediumAll>
                            <Stack spacing="100">
                                <ResourceDetailElement>{isHolding && resourceDetail}</ResourceDetailElement>
                                <ReservationDetailElement>
                                    <ReservationDetailContent>
                                        <DatesRange
                                            onClick={
                                                isHolding && this.props.onNavigateTo
                                                    ? this.handleNavigateToReservation
                                                    : undefined
                                            }
                                            startUtc={startUtc}
                                            endUtc={endUtc}
                                        />
                                        {occupancy}
                                    </ReservationDetailContent>
                                    <ReservationStateTag
                                        timeState={timeStateEnum}
                                        state={stateEnum}
                                        options={options}
                                    />
                                </ReservationDetailElement>
                                <ActionElement>
                                    <IconButton
                                        icon={IconName.Edit}
                                        onClick={this.handleEditReservation}
                                        variant="ghost"
                                        type="submit"
                                    />
                                </ActionElement>
                            </Stack>
                        </SpacingMediumAll>
                    </ReservationListItemWrapper>
                </SpacingSmallTopBottom>
            </ReservationListItem>
        );
    }
}

export default connect(
    (state, props) => ({
        // @ts-expect-error $TSFixMeError: Property 'state' does not exist on type '{}'.
        stateEnum: ServiceOrderState.getByValue(props.state),
        // @ts-expect-error $TSFixMeError: Property 'timeState' does not exist on type '{}'.
        timeStateEnum: ReservationTimeState.getByValue(props.timeState),
        // @ts-expect-error $TSFixMeError: Expected 2 arguments, but got 1.
        companionExtent: getCurrentCompanionAccommodationExtent(state),
    }),
    {
        navigateToGroupModule: navigateToReservationDetail,
    }
)(ReservationGroupDetailListItem);
